module.exports = __webpack_public_path__ + "img/nav-medicine.d1fec86c.svg";